import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.tw';

export default {
  inserted: (el, binding) => {
    el.cleave = new Cleave(el, binding.value || {});
  },
  update: (el) => {
    setTimeout(() => {
      el.value = el.cleave.properties.result;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });
  },
};
